import { useState as a, useEffect as n } from "react";
const i = {
  openKkiapayWidget: () => {
  },
  closeKkiapayWidget: () => {
  },
  addSuccessListener: () => {
  },
  addWidgetInitListener: () => {
  },
  addKkiapayCloseListener: () => {
  },
  addWidgetDestroyedListener: () => {
  },
  addPaymentInitListener: () => {
  },
  addPaymentAbortedListener: () => {
  },
  addFeedbackListener: () => {
  },
  addPendingListener: () => {
  },
  addFailedListener: () => {
  },
  addPaymentEndListener: () => {
  },
  removeKkiapayListener: () => {
  },
  addKkiapayListener: () => {
  },
  onNetworkStateChanged: () => {
  }
};
function r() {
  const [e, d] = a(i);
  return n(() => {
    (async () => {
      const t = await import("./k.es-ec9d40d3.js");
      d(t);
    })();
  }, []), e;
}
export {
  r as useKKiaPay
};
